/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_RemoveInputs */

const cs_client_merge_remove = /** @type {(inputs: Client_Merge_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sloučit a smazat (zdroj)`)
};

const en_client_merge_remove = /** @type {(inputs: Client_Merge_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge and delete (source)`)
};

/**
* | output |
* | --- |
* | "Merge and delete (source)" |
*
* @param {Client_Merge_RemoveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_remove = /** @type {((inputs?: Client_Merge_RemoveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_RemoveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_remove(inputs)
	return cs_client_merge_remove(inputs)
});